import { Editor, BaseEditor } from "slate";

/**
 * 
 * @param editor 
 * @returns if editor selection in inside a single table cell (td or th).
 */
export function checkIfSingleCellSelected(editor: BaseEditor) {
  const allCellsInSelectionGenerator = Editor.nodes(editor, {
    at: editor.selection,
    mode: "lowest",
    // @ts-ignore
    match: (node) => ['td', 'th'].includes(node.type)
  })
  const allCellsInSelection = Array.from(allCellsInSelectionGenerator)
  
  const isSingleCellSelected = allCellsInSelection.length === 1
  return isSingleCellSelected
}